import { type FC, useEffect } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { warmRoutePreloads } from "./route-preloads";

// Stay well clear of boot: the app's critical path (entry, vendor, home
// chunk, initial GraphQL) should own the first seconds; warming is a
// background concern. warmRoutePreloads itself is one-shot, so flag
// flaps or remounts can't double-warm.
const WARM_DELAY_MS = 15_000;

export const RoutePreloadWarmer: FC = () => {
  const { appIdleRoutePreloadWarming } = useFlags();

  useEffect(() => {
    if (!appIdleRoutePreloadWarming) {
      return;
    }
    const timer = setTimeout(() => void warmRoutePreloads(), WARM_DELAY_MS);
    return () => clearTimeout(timer);
  }, [appIdleRoutePreloadWarming]);

  return null;
};
